// Lightweight GA4 event helper. Safe to call even if gtag isn't loaded -
// it just no-ops. Events fire to your existing GA4 property (G-7TP6PD08D5).
//
// Usage:
//   import { track } from './utils/analytics';
//   track('plan_selected', { tier: 'dealer' });

export function track(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {}
}
